var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "estates-list" },
    [
      _vm.$root.is_mobile
        ? _c(
            "modal",
            {
              ref: "listing-map",
              attrs: {
                name: "listing-map",
                "extra-class": "full-screen-modal listing-map-modal"
              }
            },
            [
              _c("template", { slot: "body" }, [
                _c(
                  "div",
                  { staticClass: "tecnomap-container" },
                  [
                    _c("tecno-map", {
                      ref: "map",
                      staticClass: "tecnomap-listing",
                      attrs: { options: _vm.options, section: _vm.section },
                      on: { ready: _vm.loadEstates }
                    }),
                    _vm._v(" "),
                    _vm.estatesCarousel.length > 0
                      ? _c(
                          "div",
                          { staticClass: "tecnomap-estates" },
                          [
                            _c(
                              "my-carousel",
                              {
                                attrs: {
                                  "per-page-custom": [
                                    [0, 1],
                                    [768, 2],
                                    [991, 2],
                                    [1100, 3],
                                    [1200, 4]
                                  ]
                                }
                              },
                              [
                                _vm._l(_vm.estatesCarousel, function(estate) {
                                  return [
                                    _c("slide", { key: estate.id }, [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "waypoint",
                                              rawName: "v-waypoint",
                                              value: {
                                                active: true,
                                                callback: _vm.visibilityChanged,
                                                options: {}
                                              },
                                              expression:
                                                "{ active: true, callback: visibilityChanged, options: {} }"
                                            }
                                          ],
                                          staticClass: "tecnomap-estate-card",
                                          attrs: { "data-id": estate.id }
                                        },
                                        [
                                          _c("estate-card", {
                                            attrs: { estate: estate }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ]
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showList || !_vm.$root.is_mobile
        ? [
            _vm.pageSSR
              ? _vm._t("estates")
              : _vm.pageLoading
              ? _vm._l(15, function(key) {
                  return [_c("estate-card-skeleton", { key: key })]
                })
              : _vm._l(_vm.pageEstates, function(estate, index_estate) {
                  return [
                    _c("estate-card", {
                      key: estate.id,
                      attrs: {
                        estate: estate,
                        highlight: true,
                        origin: "index"
                      }
                    }),
                    _vm._v(" "),
                    _vm.config.agencies_advertising &&
                    (index_estate == 5 ||
                      (_vm.pageEstates.length < 5 &&
                        estate.id == _vm.pageEstates.at(-1).id))
                      ? _c("agencies-advertising", {
                          attrs: { search: _vm.searchFilters() }
                        })
                      : _vm._e()
                  ]
                })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.pagePagination["total_pages"] > 1
        ? _c("div", { staticClass: "w-100 text-center mx-auto p-1" }, [
            _c(
              "ul",
              { staticClass: "pagination" },
              [
                _vm.pagePagination["current_page"] > 1
                  ? [
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                _vm.pagePagination["url"] +
                                "?" +
                                _vm.pagePagination["first_page_uri"]
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.loadPage(1)
                              }
                            }
                          },
                          [_vm._v("<<")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                _vm.pagePagination["url"] +
                                _vm.pagePagination["pages_uri"][
                                  _vm.pagePagination["current_page"] - 1
                                ]
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.loadPage(
                                  _vm.pagePagination["current_page"] - 1
                                )
                              }
                            }
                          },
                          [_vm._v("<")]
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.pagePagination["pages_uri"], function(
                  page_uri,
                  page
                ) {
                  return _c("li", { key: page }, [
                    _c(
                      "a",
                      {
                        class:
                          _vm.pagePagination["current_page"] == page
                            ? " active"
                            : "",
                        attrs: { href: _vm.pagePagination["url"] + page_uri },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.loadPage(page)
                          }
                        }
                      },
                      [_vm._v(_vm._s(page))]
                    )
                  ])
                }),
                _vm._v(" "),
                _vm.pagePagination["current_page"] <
                _vm.pagePagination["total_pages"]
                  ? [
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                _vm.pagePagination["url"] +
                                _vm.pagePagination["pages_uri"][
                                  _vm.pagePagination["current_page"] + 1
                                ]
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.loadPage(
                                  _vm.pagePagination["current_page"] + 1
                                )
                              }
                            }
                          },
                          [_vm._v(">")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                _vm.pagePagination["url"] +
                                _vm.pagePagination["last_page_uri"]
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.loadPage(
                                  _vm.pagePagination["total_pages"]
                                )
                              }
                            }
                          },
                          [_vm._v(">>")]
                        )
                      ])
                    ]
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }